import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from 'pricing-pages-ui/components/common/PhoneSupport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeading = styled.h2.withConfig({
  displayName: "PhoneSupportFooter__StyledHeading",
  componentId: "sc-143tyu2-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-600'], {
    inlineSize: '70%',
    [trellisBreakpoint.tablet]: Object.assign({
      textAlign: 'center',
      inlineSize: 'auto'
    }, theme.typography['heading-300']),
    [trellisBreakpoint.phone]: Object.assign({}, theme.typography['heading-200'])
  });
});
function PhoneSupportFooter({
  phoneSourceId,
  screen,
  upgradeProduct
}) {
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(StyledHeading, {
        "data-selenium-id": "phone-support-footer-header",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.stillHaveQuestions"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        display: "inline-flex",
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          screen: screen,
          phoneSourceId: phoneSourceId,
          showCopy: false,
          showBorder: false,
          upgradeProduct: upgradeProduct
        })
      })]
    })
  });
}
export default PhoneSupportFooter;